module.exports = __webpack_public_path__ + "static/media/pexels-photo-289927.1988cf66.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/007_de/pexels-photo-289927.jpeg
// module id = 780
// module chunks = 0